import React from 'react';

const featureCategories = [
  {
    category: 'Bomberegning',
    features: [
      { name: 'Antall beregninger per måned', free: '10', premium: 'Ubegrenset' },
      { name: 'Sanntids bompriser', free: false, premium: true },
      { name: 'Historiske prisdata', free: false, premium: true },
      { name: 'EV/Hybrid rabattoptimalisering', free: false, premium: true },
      { name: 'Flerkjøretøy-beregning', free: false, premium: true },
    ],
  },
  {
    category: 'Ruteoptimalisering',
    features: [
      { name: 'Grunnleggende ruteplanlegging', free: true, premium: true },
      { name: 'Automatisk ruteoptimalisering', free: false, premium: true },
      { name: 'Lagrede ruter', free: '1 rute', premium: 'Ubegrenset' },
      { name: 'Alternativruter med kostnadssammenligning', free: false, premium: true },
      { name: 'Unngå bomstasjoner', free: false, premium: true },
    ],
  },
  {
    category: 'Trafikkdata',
    features: [
      { name: 'Grunnleggende trafikkinfo', free: true, premium: true },
      { name: 'Sanntids trafikkoppdateringer', free: false, premium: true },
      { name: 'Veiforhold og varsler', free: false, premium: true },
      { name: 'Historisk trafikkanalyse', free: false, premium: true },
    ],
  },
  {
    category: 'Rapporter & Eksport',
    features: [
      { name: 'Månedlige kostnadsrapporter', free: false, premium: true },
      { name: 'Eksport til PDF', free: false, premium: true },
      { name: 'Eksport til Excel/CSV', free: false, premium: true },
      { name: 'Kjørelogg', free: false, premium: true },
      { name: 'Skattefradragsrapport', free: false, premium: true },
    ],
  },
  {
    category: 'Kundeservice',
    features: [
      { name: 'E-poststøtte', free: true, premium: true },
      { name: 'Prioritert kundeservice', free: false, premium: true },
      { name: 'Chat-støtte', free: false, premium: true },
      { name: 'Responstid', free: '48 timer', premium: '< 4 timer' },
    ],
  },
];

const CheckIcon = ({ color = '#FF5722' }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const CrossIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(224,228,232,0.25)" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const CellValue = ({ value, isFree }) => {
  if (value === true) return <CheckIcon color={isFree ? '#004F98' : '#FF5722'} />;
  if (value === false) return <CrossIcon />;
  return (
    <span style={{
      fontFamily: 'var(--font-body)',
      fontSize: '13px',
      fontWeight: 500,
      color: isFree ? 'rgba(224,228,232,0.6)' : 'var(--color-foreground)',
    }}>{value}</span>
  );
};

const FeatureComparisonTable = () => {
  return (
    <section style={{ padding: '80px 48px', background: 'var(--color-background)', position: 'relative' }}>
      {/* Section divider */}
      <div style={{ position: 'absolute', top: 0, left: '48px', right: '48px', height: '1px', background: 'rgba(224,228,232,0.06)' }} />

      <div style={{ maxWidth: '1440px', margin: '0 auto' }}>
        {/* Section header */}
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <div style={{ display: 'inline-block', background: 'rgba(0,79,152,0.1)', border: '1px solid rgba(0,79,152,0.2)', borderRadius: '2px', padding: '4px 12px', marginBottom: '20px' }}>
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#004F98' }}>Sammenligning</span>
          </div>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '36px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '-0.01em', marginBottom: '12px' }}>Detaljert funksjonssammenligning</h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '15px', color: 'var(--color-muted-foreground)', maxWidth: '480px', margin: '0 auto', lineHeight: 1.6 }}>Se nøyaktig hva som er inkludert i hver plan.</p>
        </div>

        {/* Table */}
        <div style={{ maxWidth: '860px', margin: '0 auto', border: '1px solid rgba(224,228,232,0.08)', borderRadius: '2px', overflow: 'hidden' }}>
          {/* Table header */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 160px 160px', background: 'rgba(255,255,255,0.03)', borderBottom: '2px solid rgba(224,228,232,0.08)' }}>
            <div style={{ padding: '20px 28px' }}>
              <span style={{ fontFamily: 'var(--font-heading)', fontSize: '12px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--color-muted-foreground)' }}>Funksjon</span>
            </div>
            <div style={{ padding: '20px 28px', textAlign: 'center', borderLeft: '1px solid rgba(224,228,232,0.06)' }}>
              <span style={{ fontFamily: 'var(--font-heading)', fontSize: '14px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '0.04em' }}>Gratis</span>
            </div>
            <div style={{ padding: '20px 28px', textAlign: 'center', borderLeft: '1px solid rgba(224,228,232,0.06)', background: 'rgba(255,87,34,0.04)' }}>
              <span style={{ fontFamily: 'var(--font-heading)', fontSize: '14px', fontWeight: 700, color: '#FF5722', letterSpacing: '0.04em' }}>Premium</span>
            </div>
          </div>

          {/* Categories */}
          {featureCategories?.map((cat, catIdx) => (
            <div key={cat?.category}>
              {/* Category header */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 160px 160px', background: 'rgba(0,79,152,0.06)', borderTop: catIdx > 0 ? '1px solid rgba(224,228,232,0.06)' : 'none' }}>
                <div style={{ padding: '14px 28px', gridColumn: '1 / -1' }}>
                  <span style={{ fontFamily: 'var(--font-heading)', fontSize: '20px', fontWeight: 600, color: 'var(--color-foreground)', letterSpacing: '0.01em' }}>{cat?.category}</span>
                </div>
              </div>

              {/* Feature rows */}
              {cat?.features?.map((feat, featIdx) => (
                <div
                  key={feat?.name}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 160px 160px',
                    borderTop: '1px solid rgba(224,228,232,0.04)',
                    background: featIdx % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.01)',
                    transition: 'background 150ms ease',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.03)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = featIdx % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.01)'; }}
                >
                  <div style={{ padding: '14px 28px' }}>
                    <span style={{ fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 400, color: 'rgba(224,228,232,0.75)', lineHeight: 1.5 }}>{feat?.name}</span>
                  </div>
                  <div style={{ padding: '14px 28px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderLeft: '1px solid rgba(224,228,232,0.04)' }}>
                    <CellValue value={feat?.free} isFree={true} />
                  </div>
                  <div style={{ padding: '14px 28px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderLeft: '1px solid rgba(224,228,232,0.04)', background: 'rgba(255,87,34,0.02)' }}>
                    <CellValue value={feat?.premium} isFree={false} />
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureComparisonTable;
